<template>
  <b-container class="my-5">
    <b-row>
      <b-col xl="12">
        <b-card no-body>
          <h3 class="card-header bg-white">Registrarse en
            <b>Listado Médico</b>
            <small class="d-block" style="font-size: 65%">Regresar al
              <b-link class="card-link" href="/"> sitio web</b-link>.
            </small>
          </h3>
          <b-card-body>
            <b-form @submit="onSubmit" @reset="onReset">
              <b-form-row>
                <b-form-group
                  class="col-md-6"
                  id="label-firstName"
                  label="Nombre"
                  label-for="firstName">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','user']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="firstName"
                      v-model="form.data.firstName"
                      placeholder="Nombre"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-6"
                  id="label-lastName"
                  label="Apellidos"
                  label-for="lastName">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','user']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="lastName"
                      v-model="form.data.lastName"
                      placeholder="Apellidos"
                      trim />
                  </b-input-group>
                </b-form-group>
              </b-form-row>
              <b-form-row>
                <b-form-group
                  class="col-md-6"
                  id="label-email"
                  label="Email"
                  label-for="email">
                  <b-input-group prepend="@">
                    <b-form-input
                      id="email"
                      type="email"
                      v-model="form.data.email"
                      placeholder="Email"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-6"
                  id="label-password"
                  label="Password"
                  label-for="password">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','key']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="password"
                      type="password"
                      v-model="form.data.password"
                      placeholder="Password"
                      trim />
                  </b-input-group>
                </b-form-group>
              </b-form-row>
              <b-form-row>
                <b-form-group
                  class="col-md-6"
                  id="label-professionalLicense"
                  label="Cédula profesional"
                  label-for="professionalLicense">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','id-card']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="professionalLicense"
                      v-model="form.data.professionalLicense"
                      placeholder="Cédula profesional"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-6"
                  id="label-rfc"
                  label="RFC"
                  label-for="rfc">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','id-card']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="rfc"
                      v-model="form.data.rfc"
                      placeholder="RFC"
                      trim />
                  </b-input-group>
                </b-form-group>
              </b-form-row>
              <b-form-group>
                <div id="recaptcha" class="g-recaptcha" :data-sitekey="rcapt_sig_key"></div>
              </b-form-group>
              <b-button variant="success" type="submit" value="signup" name="submit">Registrar</b-button>
              <b-link class="btn btn-link" to="/signin">Ya tengo una cuenta</b-link>
              <b-link class="btn btn-link" to="/profile-claim">Reclamar perfil existente</b-link>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col xl="12">
        <adsense
          ad-slot="9585150092"
          ad-format="auto"
          ad-client="ca-pub-1844310477126911"
          ad-style="display:block">
        </adsense>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Adsense from '@/components/Adsense'

export default {
  components: { Adsense },
  name: 'Signup',
  data () {
    return {
      rcapt_sig_key: '6LfckXMUAAAAAKAF6dDc-lXeTo-cjrwH29nG3dbV',
      rcapt_id: '',
      form: {
        data: {
          recaptcha: '',
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          professionalLicense: '',
          rfc: ''
        }
      }
    }
  },
  mounted () {
    if (window.grecaptcha) {
      this.rcapt_id = window.grecaptcha.render(
        document.getElementById('recaptcha'),
        { sitekey: this.rcapt_sig_key })
    }
  },
  methods: {
    onSubmit: async function (event) {
      event.preventDefault()
      this.form.data.g_recaptcha_response = window.grecaptcha.getResponse(this.rcapt_id)
      try {
        const response = await this.$http.post('/signup', this.form.data)
        this.$store.commit('setDoctor', response.data)
        this.$router.push('/offices')
      } catch (error) {
        const err = error.response.data.errors[0]
        this.$bvToast.toast(err.message, {
          title: 'Error creado cuenta',
          autoHideDelay: 5000
        })
        window.grecaptcha.reset()
      }
    },
    onReset: async function (event) {

    }
  }
}
</script>
